import "@webhare-system/frameworks/mootools/core";
var JSONRPC = require('@webhare-system/net/jsonrpc');
var WHBase = require('@webhare-system/compat/base');

var editorsupportrpc;

function editorsupport_rpc_init()
{
  editorsupportrpc = new JSONRPC({ onError: onEditorSupportRPCError.bind(this)
                                 , url:     "/.tollium/ui/editorsupport.shtml"
                                 });
  window.store("wheditorsupport_rpc", editorsupportrpc); //FIXME avoid this 'moo' dependency. not sure why we even need to export anything ?
}

function onEditorSupportRPCError(result)
{
  if(WHBase.debug) //fixme this was $wh.debug but that doesn't really do anything
  {
    //alert("Unable to contact the WebHare RPC endpoint; try again at a later time.");
    console.error("RPC Error:");
    console.warn(result);
  }
}

function openInSublime(path, line, column)
{
  editorsupportrpc.request("OpenInSublime", [ { path: path, line: line || 0, col: column || 0, source: window.location.href, hash: window.location.hash, siteroot: WHBase.config.siteroot} ], function(result){});
}

function revealInFinder(path)
{
  editorsupportrpc.request("RevealInFinder", [ { path: path, source: window.location.href, hash: window.location.hash, siteroot: WHBase.config.siteroot} ], function(result){});
}

function openInSublimeFromHTMLElement(elem)
{
  console.log(elem);
  var highest = elem;
  while(highest.nodeName.toLowerCase() != "t-screen" && highest.nodeName.toLowerCase() != "body")
    highest = highest.parentNode;

  if(highest.nodeName.toLowerCase() != "t-screen")
  {
    console.log("Unable to find t-screen ancestor; halted at", highest.nodeName);
    return;/// Unable to find a t-screen node
  }

  var lib = highest.getAttribute("data-tolliumscreen");
  if(lib.indexOf("#") > 0)
    lib = lib.substring(0, lib.indexOf("#"));

  openInSublime(lib);
}

window.addEvent("domready", editorsupport_rpc_init);

module.exports = { openInSublime
                 , revealInFinder
                 , openInSublimeFromHTMLElement
                 };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/editorsupport.es